import * as Sentry from '@sentry/react';
import useAppRoutes from '@/routes/routes';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface SentryErrorProps {
  children: ReactNode;
}

const SentryError = ({ children }: SentryErrorProps) => {
  const routes = useAppRoutes();

  return (
    <Sentry.ErrorBoundary fallback={<Navigate to={routes.errorSite404()} />}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryError;
